<div *ngIf="pageData" class="sk-static-page-container">

  <h1 class="mb-4 user-select-none" [innerText]="pageData.title"></h1>

  <markdown [data]="pageData['text']"></markdown>

</div>
